import React, { Component } from 'react';
import Relay from 'react-relay';
import moment from 'moment';
import 'moment-timezone';
import styler from 'react-styling';
import { Grid, Row, Col } from 'react-bootstrap/lib';

import { EventModal, CreateEventModal, Event, RangeDate, EventLoading } from '../index';
import { convertEvent } from '../../libs/Extract';

function _createStyle(width) {
  return styler `
    Scheduler
      height: 100%
      overflow: hidden
    Datepicker
      width: 300px
      margin-top: 40px
      margin-bottom: 40px
    ContactsHeader
      width: 25%
      background-color: #FFF
      height: 60px
      float: left
      align-items: center
      padding-left: 15px
      font-size: 20px
      display: flex
      border: 1px solid #ECECEC
      border-bottom: 0
    Wrap
      width: 75%
      display: flex
    New
      height: 60px
      background-color: #182B56
      color: #FFF
      font-size: 20px
      font-weight: 500
      transition: all 0.25s ease-out 0ms
      -webkit-transition: all 0.25s ease-out 0ms
      width: 100%
      text-align: center
      border: 1px solid #ECECEC
      border-left: 0
      border-bottom: 0
      border-radius: 0
      justify-content: center
      align-items: center
      display: flex
      padding-bottom: 2px
      float: left
      flex: 1
    Multimonths
      font-size: 12px
    NewText
      display: inline
      text-transform: none
      font-weight: 400
      margin-left: 10px
    NewTextSmall
      display: block
      margin-left: 0
      text-transform: none
      font-weight: 400
    IconCal
      font-size: 18px
    IconCalSmall
      font-size: 12px
      margin-left: 5px
    IconClock
      font-size: 12px
      text-align: right
      margin-right: 5px
    Table
      padding-right: 0
      padding-left: 0
      padding-bottom: 30px
      margin-top: 30px
      overflow-y: auto
      overflow-x: hidden
      max-height: calc(100% - 313px)
    Time
      height: 30px
      background-color: #F5F5F5
      position: fixed
      margin-left: -15px
      width: calc(100% - ${width || 534}px)
      z-index: 3
  `;
}

class Scheduler extends Component {

  static defaultProps = {
    forceFetch: () => {},
  };

  constructor(props) {
    super(props);
    const { hoursSlots, daysSlots } = this.calculateSchedulerHoursSlots(
      this.props.startDate,
      this.props.endDate
    );

    this.state = {
      schedulerDateMin: {},
      schedulerDateMax: {},
      events: {},
      showCalendar: false,
      schedulerHours: hoursSlots,
      schedulerDays: daysSlots,
      dateSelectedToCreateEvent: {},
      eventSelected: {},
      modalShowEvent: false,
      datePickerStart: this.props.startDate,
      datePickerEnd: this.props.endDate,
      // if event modal is open or not  (should move this state to store)
      isCreateEventModalOpen: false,
    };
  }

  props: {
    relay: Object,
    viewer: Object,
    startDate: string,
    endDate: string,
    languagedata: Object,
    setDateRange: Function,
    contactsSelected: Array<Object>,
    changeSelectedTo: Function,
    contact: Object,
    forceFetch: Function,
    width: number,
  };

  _renderEvents = (resources: any) => {
    const events = resources.map((resource, index) =>
      <Relay.Renderer
        environment={Relay.Store}
        Container={Event}
        queryConfig={{
          queries: {
            event: () => Relay.QL`query { viewer }`,
          },
          name: 'EventViewQueries',
          params: {
            emails: [resource.email],
            startDate: this.props.relay.variables.startDate,
            endDate: this.props.relay.variables.endDate,
          },
        }}
        // eslint-disable-next-line
        render={({ done, error, props, retry, stale }) => {
          if (error) {
            return <p>{error}</p>;
          } else if (props) {
            return (
              <Event
                key={index}
                event={this.props.viewer}
                startDate={this.props.relay.variables.startDate}
                endDate={this.props.relay.variables.endDate}
                emails={[resource.email]}
                displayName={resource.displayName}
                schedulerHours={this.state.schedulerHours.length}
                datePickerStart={this.state.datePickerStart}
                datePickerEnd={this.state.datePickerEnd}
                languagedata={this.props.languagedata}
                showEventModal={this._showEventModal}
              />);
          }
          return (<EventLoading displayName={resource.displayName} />);
        }}
      />
    );
    return events;
  }
  calculateSchedulerHoursSlots = (startDate, endDate) => {
    const schedulerStartDate = moment(startDate).hour(7).minutes(0).second(0);
    const schedulerEndDate = moment(endDate).hour(19).minutes(59).second(59);
    const duration = schedulerEndDate.diff(schedulerStartDate, 'minutes') / 60; // eks 23,5
    const hours = Math.ceil(duration); // get full days - 24 hours
    const days = endDate.endOf('day').diff(startDate.startOf('day'), 'days') + 1;

    const h = hours;
    const d1 = schedulerStartDate;
    const d2 = moment(startDate).startOf('day');
    const hoursSlots = [];
    const daysSlots = [];
    for (let i = 0; i < h; i++) { // hours slots
      const obj = {};
      obj.hour = d1.format('H');
      obj.start = d1.format();
      d1.add(1, 'hours').format();
      obj.end = d1.format();
      hoursSlots.push(obj);
    }
    for (let i = 0; i < days; i++) { // days slots
      const hoursToNow = moment().diff(moment().startOf('day'), 'hours') + 1;
      const timeNow = moment(d2).add(hoursToNow, 'hours');
      const obj = {};
      obj.start = timeNow;
      obj.end = moment(timeNow).add(30, 'minutes');
      d2.add(1, 'days').format();
      daysSlots.push(obj);
    }
    return { hoursSlots, daysSlots };
  }

  handleSelectDateRange = (date) => {
    const startDate = moment(date.startDate).startOf('day');
    const endDate = moment(date.endDate).endOf('day');
    const duration = endDate.endOf('day').diff(startDate.startOf('day'), 'minutes') / 60; // eks 23,5
    const hours = Math.ceil(duration); // get full days - 24 hours
    // const days = endDate.endOf('day').diff(startDate.startOf('day'), 'days') + 1;

    const { hoursSlots, daysSlots } = this.calculateSchedulerHoursSlots(startDate, endDate);

    if (hours === 0) {
      this.setState({
        schedulerDateMax: startDate.clone().add(1, 'months'),
        schedulerDateMin: endDate.clone().subtract(1, 'months'),
        schedulerHours: hoursSlots,
        schedulerDays: daysSlots,
        datePickerStart: startDate,
        datePickerEnd: endDate,
      });
    } else {
      this.setState({
        schedulerDateMax: {},
        schedulerDateMin: {},
        schedulerHours: hoursSlots,
        schedulerDays: daysSlots,
        datePickerStart: startDate,
        datePickerEnd: endDate,
      });
    }
    this.props.setDateRange(startDate, endDate);
  }


  // open modal and pass date
  modalMakeNewEvent = (date) => {
    this.setState({
      isCreateEventModalOpen: true,
      dateSelectedToCreateEvent: date,
    });
  }

  closeCreateEventModal = () => {
    this.setState({ isCreateEventModalOpen: false });
  }

  _showEventModal = (event) => {
    const eventCopy = convertEvent(event);
    this.setState({ eventSelected: eventCopy });
    this.setState({ modalShowEvent: true });
  }

  _closeEventModal = () => {
    this.setState({ modalShowEvent: false });
  }

  _forceFetch = () => {
    this.props.forceFetch();
    this.setState({
      isCreateEventModalOpen: false,
    });
  }

  render() {
    const style = _createStyle(this.props.width);
    const lang = this.props.languagedata;
    return (
      <Grid fluid style={style.Scheduler} className="scheduler">
        <div className="row2">
          <Col xs={12} className="padding-0">
            <Grid fluid>
              <Row>
                <Col style={style.Datepicker}>
                  <RangeDate
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}
                    handleSelectDateRange={this.handleSelectDateRange}
                    schedulerDateMax={this.state.schedulerDateMax}
                    schedulerDateMin={this.state.schedulerDateMin}
                    languagedata={this.props.languagedata}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div style={style.ContactsHeader}>
                    <span>{this.props.languagedata.resources}</span>
                  </div>
                  <div style={style.Wrap}>
                    {this.state.schedulerDays.map((day, index) => (
                      <div key={index} style={style.New} className="newbutton" onClick={() => this.modalMakeNewEvent(day)} title={lang.create_new_event}>
                        {this.state.schedulerDays.length < 3 ?
                            (<div>{day.start.format('MMMM DD')}
                              <i className="fa fa-calendar-plus-o" style={style.IconCal} />
                              <span style={style.NewText}>{this.props.languagedata.create_new_event}</span>
                            </div>) :
                            (<div style={style.Multimonths}>{day.start.format('MMM DD')}
                              <i className="fa fa-calendar-plus-o" style={style.IconCalSmall} />
                              <span style={style.NewTextSmall}>{this.props.languagedata.create_new_event}</span>
                            </div>)
                          }
                      </div>
                      ))}
                  </div>
                </Col>
              </Row>
              <Row style={style.Time} className="absolute-slots">
                <Col xs={3} className="slots">
                  <div className="slot">
                    <p style={style.IconClock}><i className="fa fa-clock-o" /></p>
                  </div>
                </Col>
                <Col xs={9} className="slots">
                  {this.state.schedulerHours.map((hour) => (
                    <div className="slot">
                      <small>{hour.hour}</small>
                    </div>
                  ))}
                </Col>
              </Row>
            </Grid>

            <Grid fluid style={style.Table}>
              { this.state.schedulerHours.length > 24 && // show if more than one day
              <Row className="multislots-wrapper">
                <Col xs={3} className="multislots"><div className="slot">&nbsp;</div></Col>
                <Col xs={9} className="multislots">
                  <div className="slot">
                    {this.props.startDate.format('L')} - {this.props.endDate.format('L')}
                  </div>
                </Col>
              </Row>
              }
              <div className="schedule-wrap">
                {(this.state.schedulerHours.length <= 24) ?
                  <Row className="absolute-slots" style={{ marginTop: '-30px' }}>
                    <Col xs={3} className="slots">
                      <div className="slot">
                        <p style={style.IconClock}><i className="fa fa-clock-o" /></p>
                      </div>
                    </Col>
                    <Col xs={9} className="slots">
                      {this.state.schedulerHours.map((hour, index) => (
                        <div key={index} className="slot book" onClick={() => this.modalMakeNewEvent(hour)} title={lang.create_new_event}>
                          <small>{hour.hour}</small>
                        </div>
                      ))}
                    </Col>
                  </Row>
                : null}

                <div className={(this.state.schedulerHours.length > 24) ? 'wrap-users wrap-users--no-padding' : 'wrap-users'}>
                  {this._renderEvents(this.props.contactsSelected)}
                </div>
              </div>
            </Grid>
          </Col>
        </div>
        {this.state.isCreateEventModalOpen ? (
          <CreateEventModal
            isCreateEventModalOpen={this.state.isCreateEventModalOpen}
            dateSelectedToCreateEvent={this.state.dateSelectedToCreateEvent} // { end: date, start: date, hour: number}
            LocalLanguageData={lang}
            viewer={this.props.viewer}
            closeCreateEventModal={() => this.closeCreateEventModal()}
            changeSelectedTo={this.props.changeSelectedTo}
            contactsSelected={this.props.contactsSelected}
            contact={this.props.contact}
            forceFetch={this._forceFetch}
            parent="scheduler"
          />
        ) : (null)}

        {this.state.modalShowEvent ? (
          <EventModal
            show={this.state.modalShowEvent}
            close={this._closeEventModal}
            event={this.state.eventSelected}
            languagedata={this.props.languagedata}
          />
        ) : (null)}

      </Grid>
    );
  }
}

export default Scheduler;



// WEBPACK FOOTER //
// ./src/js/Components/Scheduler/Scheduler.js